import React from 'react';
import { Table } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import { getLookupName } from './util';

const CitizenshipTableRow = (props) => {
    let c = props.citizenships ? props.citizenships : [];
    return (
        <Table.Row>
            <Table.Cell textAlign="right">
                <b>{<FormattedMessage id="common.citizenship" />}</b>
            </Table.Cell>
            <Table.Cell verticalAlign="middle">
                {c.map((el, i) =>
                    (<div key={i}>
                        {getLookupName(el.country)}

                        {(i === c - 1) ? null : <br />}
                    </div>))}
            </Table.Cell>
        </Table.Row>
    );
};

export default CitizenshipTableRow;



// WEBPACK FOOTER //
// ./src/views/StudentPersonalInfo/CitizenshipTableRow.js